import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';
import { Observable } from 'rxjs';
import { SourceAdviceCategory } from '@referrals/shared/models';

@Injectable({
  providedIn: 'root',
})
export class SourceAdviceCategoryService {
  private headers: HttpHeaders;
  private accessPointUrl: string;

  constructor(private config: ConfigService, private http: HttpClient) {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
    });
    this.accessPointUrl = `${this.config.referralsApiUrl}/sourceadvicecategories`;
  }

  public get(): Observable<SourceAdviceCategory[]> {
    return this.http.get<SourceAdviceCategory[]>(this.accessPointUrl, {
      headers: this.headers,
    });
  }

  public getById(id: number): Observable<SourceAdviceCategory[]> {
    return this.http.get<SourceAdviceCategory[]>(
      this.accessPointUrl + '/' + id,
      {
        headers: this.headers,
      }
    );
  }

  public add(payload): Observable<SourceAdviceCategory> {
    return this.http.post<SourceAdviceCategory>(this.accessPointUrl, payload, {
      headers: this.headers,
    });
  }

  public update(payload): Observable<SourceAdviceCategory> {
    return this.http.put<SourceAdviceCategory>(
      this.accessPointUrl + '/' + payload.id,
      payload,
      {
        headers: this.headers,
      }
    );
  }

  public delete(id: number): Observable<any> {
    return this.http.delete(this.accessPointUrl + '/' + id, {
      headers: this.headers,
    });
  }
}
